import React from "react";
import { PageHeaderProps } from "./types";

/**
 * Zaglavlje stranice.
 *
 * Crta ide na samo zaglavlje, ne na vodoravni izbornik ispod njega. U korisničkoj aplikaciji
 * ju nosi `TabMenu`, pa je na ekranima bez tabova nema — a u administraciji ih većina nema.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ children }) => {
  return (
    <>
      <div className=" px-3 pt-2 xl:px-6 xl:pt-4 pb-4  ">
        {children}
      </div>
    </>
  );
};

export default React.memo(PageHeader);
